/*
 * gs-reviews.js — behaviour for sections/gs-custom-2.liquid.
 * Clicking a review photo opens a full-screen lightbox with the full-size image.
 */
(function () {
  function init(root) {
    if (!root || root.dataset.gsInit === 'true') return;
    root.dataset.gsInit = 'true';

    var lightbox = root.querySelector('[data-gs-review-lightbox]');
    var lightboxImg = root.querySelector('[data-gs-review-lightbox-img]');
    var closeBtn = root.querySelector('[data-gs-review-lightbox-close]');
    if (!lightbox || !lightboxImg) return;

    function open(url) {
      lightboxImg.src = url;
      lightbox.classList.add('is-open');
    }

    function close() {
      lightbox.classList.remove('is-open');
      lightboxImg.src = '';
    }

    root.querySelectorAll('[data-gs-review-photo]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var url = btn.dataset.imageUrl;
        if (url) open(url);
      });
    });

    if (closeBtn) closeBtn.addEventListener('click', close);
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });

    var moreBtn = root.querySelector('[data-gs-review-more]');
    var moreArea = root.querySelector('[data-gs-review-more-area]');
    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        root.querySelectorAll('[data-gs-card][hidden]').forEach(function (card) {
          card.hidden = false;
        });
        if (moreArea) moreArea.hidden = true;
      });
    }
  }

  document.querySelectorAll('[data-gs-reviews]').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector && e.target.querySelector('[data-gs-reviews]');
    if (root) init(root);
  });
})();
